import React from 'react'
import { Form, Modal, Button } from 'react-bootstrap'
import * as Icon from "react-bootstrap-icons";
import RejectShield from "../../../Assets/RejectShield.svg"

const RejectModal = ({ show, toggle, onSubmit, error, rejectReason, setRejectReason }) => {
    return (
        <Modal size='md' show={show} backdrop='static' keyboard={false} centered onHide={toggle}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <h5 className='mb-0'>
                        <Icon.XCircleFill size={20} className='me-2' color='red' />
                        Reject Survey
                    </h5>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className='text-center'>

                <div data-aos='zoom-in'>
                    <img src={RejectShield} alt="Aprrove Survey" width={80} height={80} />
                    <h4 style={{ fontWeight: '600', marginTop: '6px' }}>Are you sure to reject this survey ?</h4>
                    <Form.Group className='text-start mt-3 px-3'>
                        <Form.Label><span>*</span> Enter reject reason to continue</Form.Label>
                        <Form.Control placeholder='Enter reason' value={rejectReason}
                            onChange={(e) => setRejectReason(e.target.value)} />
                    </Form.Group>
                </div>
                {error && <p className="errMsg">{error}</p>}
            </Modal.Body>

            <Modal.Footer>
                <Button className='btn-login me-3' onClick={onSubmit}>
                    <Icon.HandThumbsUp className='me-1' />Yes</Button>
                <Button className='btn-submit' onClick={toggle}>
                    <Icon.HandThumbsDown className='me-1' />No</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default RejectModal